import { GroupIds } from "@/configuration/group-ids";
import {
  type SchedulingCustomerConfig,
  SchedulingSmsAvailabilityStrategy,
  SchedulingSmsEligibilityStrategy,
} from "@/customer-interface/scheduling";

/** Common Voice scheduling is sandbox-only. Live Voice and SMS require separate rollout decisions. */
export const entpartnersSchedulingConfig = {
  appointmentQuery: {
    enabledGroupIds: { VOICE: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX] },
  },
  locationQuery: {
    enabledGroupIds: {
      SMS: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
      VOICE: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    },
  },
  policy: {
    scheduleConfigPath: "configuration/groups/entpartners/rules/schedule.yaml",
  },
  voice: {
    workflow: "deterministic",
    workflowEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    cancellation: "direct",
    optionSearch: {
      progressiveChronologicalWindows: true,
      progressivePolicyRankedWindows: false,
      progressiveLinkedUnitWindows: false,
    },
  },
  // Select sandbox scheduling; SMS appointment reads and live groups retain their current paths.
  sms: {
    eligibility: SchedulingSmsEligibilityStrategy.Agentic,
    eligibilityEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    availability: SchedulingSmsAvailabilityStrategy.AgenticProvider,
    availabilityEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    bookingEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
  },
} as const satisfies SchedulingCustomerConfig;
